const RightArrow = () => {
  return (
    <svg fill="white" version="1.1" id="Capa_1" width="24px" height="24px" viewBox="0 0 97.283 97.283">
      <g>
        <path
          d="M62.805,83.951l33.894-33.896c0.78-0.781,0.78-2.047,0-2.828L62.805,13.332c-0.781-0.781-2.047-0.781-2.828,0l-9.031,9.03
		c-0.375,0.375-0.586,0.883-0.586,1.414c0,0.53,0.211,1.039,0.586,1.414l14.531,14.534H2c-1.104,0-2,0.896-2,2v13.835
		c0,1.104,0.896,2,2,2h63.479L50.945,72.091c-0.75,0.75-0.75,2.078,0,2.828l9.031,9.031c0.375,0.375,0.883,0.586,1.414,0.586
		C61.92,84.537,62.43,84.326,62.805,83.951z"
        />
      </g>
    </svg>
  );
};

const CopyIcon = (props) => {
  return (
    <svg id="Copy" width={20} height={20} viewBox="0 0 24 24" {...props}>
      <rect width={24} height={24} stroke="none" fill="#000000" opacity={0} />
      <g transform="matrix(1 0 0 1 12 12)">
        <path
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "rgb(0,0,0)",
            fillRule: "nonzero",
            opacity: 1,
          }}
          transform=" translate(-12, -12)"
          d="M 4 2 C 2.895 2 2 2.895 2 4 L 2 17 C 2 17.552 2.448 18 3 18 C 3.552 18 4 17.552 4 17 L 4 4 L 17 4 C 17.552 4 18 3.552 18 3 C 18 2.448 17.552 2 17 2 L 4 2 z M 8 6 C 6.895 6 6 6.895 6 8 L 6 20 C 6 21.105 6.895 22 8 22 L 20 22 C 21.105 22 22 21.105 22 20 L 22 8 C 22 6.895 21.105 6 20 6 L 8 6 z M 8 8 L 20 8 L 20 20 L 8 20 L 8 8 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

const ShareIcon = (props) => {
  return (
    <svg id="Share 3" width={20} height={20} viewBox="0 0 24 24" {...props}>
      <rect width={24} height={24} stroke="none" fill="currentColor" opacity={0} />
      <g transform="matrix(0.56 0 0 0.56 12 12)">
        <path
          style={{
            stroke: "none",
            strokeWidth: 1,
            strokeDasharray: "none",
            strokeLinecap: "butt",
            strokeDashoffset: 0,
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            fill: "currentColor",
            fillRule: "nonzero",
            opacity: 1,
          }}
          transform=" translate(-24.01, -23.99)"
          d="M 35.484375 5.984375 C 34.8737299938182 5.9845239424250645 34.3241142665067 6.354797916566635 34.09459221039481 6.920666250648674 C 33.86507015428292 7.4865345847307125 34.0014518357354 8.135056211663032 34.439453 8.560546900000002 L 36.878906 11 L 35.5 11 C 23.64339 11 14 20.64339 14 32.5 C 13.992349565681769 33.040953874866354 14.276562944253993 33.54412204685742 14.743809274571493 33.81683158222979 C 15.211055604888994 34.08954111760215 15.788944395111008 34.08954111760215 16.256190725428507 33.81683158222978 C 16.723437055746007 33.54412204685742 17.007650434318233 33.040953874866354 17 32.5 C 17 22.26461 25.26461 14 35.5 14 L 36.878906 14 L 34.439453 16.439453 C 34.04760650892017 16.81568119512626 33.88976557766029 17.37434971051894 34.02680278146244 17.90000371473999 C 34.163839985264595 18.425657718961045 34.57434228103895 18.83616001473541 35.099996285260005 18.97319721853756 C 35.625650289481065 19.11023442233971 36.18431880487374 18.95239349107983 36.560547 18.560547 L 41.431641 13.689453 C 41.80319650612876 13.404500191084743 42.02038835487938 12.962399034261637 42.018855554532266 12.494158446565113 C 42.017322754185145 12.02591785886859 41.79724112707124 11.585248130574325 41.423828 11.302734 L 36.560547 6.4394531 C 36.27806812925463 6.14855184651476 35.88985971171693 5.984391146313432 35.484375 5.984375 z M 12.5 6 C 8.9280619 6 6 8.9280619 6 12.5 L 6 35.5 C 6 39.071938 8.9280619 42 12.5 42 L 35.5 42 C 39.071938 42 42 39.071938 42 35.5 L 42 27.5 C 42.00765043431823 26.959046125133643 41.72343705574601 26.455877953142583 41.25619072542851 26.183168417770215 C 40.78894439511101 25.910458882397847 40.21105560488899 25.910458882397847 39.74380927457149 26.183168417770215 C 39.27656294425399 26.455877953142583 38.99234956568177 26.959046125133643 39 27.5 L 39 35.5 C 39 37.450062 37.450062 39 35.5 39 L 12.5 39 C 10.549938 39 9 37.450062 9 35.5 L 9 12.5 C 9 10.549938 10.549938 9 12.5 9 L 20.5 9 C 21.040953874866357 9.007650434318231 21.544122046857417 8.723437055746007 21.816831582229785 8.256190725428507 C 22.089541117602153 7.788944395111007 22.089541117602153 7.211055604888992 21.816831582229785 6.743809274571492 C 21.544122046857417 6.2765629442539925 21.040953874866357 5.992349565681768 20.5 6 L 12.5 6 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

const WarningIcon = (props) => {
  return (
    <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v4m0 4h.01M4.93 19h14.14c1.23 0 1.91-1.4 1.2-2.4L13.2 4.6c-.71-1-2.49-1-3.2 0L3.73 16.6c-.71 1 .03 2.4 1.2 2.4z"
      />
    </svg>
  );
};
export { RightArrow, CopyIcon, ShareIcon, WarningIcon };
